(function () {
  const NORM = (s) =>
    (s || '')
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const ABSURL = (href) => {
    try {
      return new URL(href, location.origin).toString();
    } catch {
      return href || '';
    }
  };

  /* ---------- FAQ: select & extract ---------- */
  function selectAllFAQPages() {
    return document.querySelectorAll('[itemscope][itemtype="https://schema.org/FAQPage"],[itemscope][itemtype="http://schema.org/FAQPage"]');
  }

  function getQuestionsWithin(faqRoot) {
    return faqRoot.querySelectorAll('[itemscope][itemprop="mainEntity"][itemtype$="schema.org/Question"],[itemscope][itemtype$="schema.org/Question"]');
  }

  function extractQA(qNode) {
    const nameEl = qNode.querySelector('[itemprop="name"]') || qNode.querySelector('h1,h2,h3,h4,h5,h6');
    const question = NORM(nameEl ? nameEl.textContent : '');

    const ansNode = qNode.querySelector('[itemscope][itemprop="acceptedAnswer"][itemtype$="schema.org/Answer"]');
    const textEl = ansNode ? ansNode.querySelector('[itemprop="text"]') || ansNode : null;

    const answer = NORM(textEl ? textEl.textContent : '');
    if (!question || !answer) return null;

    return {
      '@type': 'Question',
      name: question,
      acceptedAnswer: { '@type': 'Answer', text: answer },
    };
  }

  function collectFAQEntities() {
    const pages = selectAllFAQPages();
    const out = [];

    pages.forEach((root) => {
      const questions = getQuestionsWithin(root);
      const entities = [];
      questions.forEach((q) => {
        const qa = extractQA(q);
        if (qa) entities.push(qa);
      });

      if (entities.length) {
        const data = {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: entities,
        };
        const itemId = root.getAttribute('itemid');
        if (itemId) data['@id'] = itemId;

        out.push(data);
      }
    });

    return out;
  }

  /* ---------- Breadcrumbs: select & extract ---------- */
  function selectAllBreadcrumbLists() {
    return document.querySelectorAll('[itemscope][itemtype="https://schema.org/BreadcrumbList"],[itemscope][itemtype="http://schema.org/BreadcrumbList"]');
  }

  function extractBreadcrumbList(bcRoot) {
    const items = Array.from(bcRoot.querySelectorAll('[itemprop="itemListElement"][itemscope][itemtype$="schema.org/ListItem"]'));

    if (!items.length) return null;

    const elements = items.map((li, idx) => {
      // naam
      const nameEl = li.querySelector('[itemprop="name"]') || li.querySelector('[itemprop="item"] [itemprop="name"]') || li.querySelector('a,span');
      const name = NORM(nameEl ? nameEl.textContent : '');

      // url
      const itemEl = li.querySelector('[itemprop="item"]') || li.querySelector('a');
      const href = itemEl ? itemEl.getAttribute('href') || itemEl.getAttribute('content') : '';
      const url = href ? ABSURL(href) : '';

      // positie (forceer sequentieel als fallback)
      const posMeta = li.querySelector('meta[itemprop="position"]');
      const posFromMeta = posMeta ? parseInt(posMeta.getAttribute('content') || '', 10) : NaN;
      const position = Number.isFinite(posFromMeta) && posFromMeta > 0 ? posFromMeta : idx + 1;

      const listItem = {
        '@type': 'ListItem',
        position,
        item: { '@type': 'WebPage', name },
      };

      if (url) listItem.item['@id'] = url;
      return listItem;
    });

    // Sorteer op position en hernummer sequentieel voor de zekerheid
    elements
      .sort((a, b) => a.position - b.position)
      .forEach((el, i) => {
        el.position = i + 1;
      });

    const data = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: elements,
    };

    const itemId = bcRoot.getAttribute('itemid');
    if (itemId) data['@id'] = itemId;

    return data;
  }

  function collectBreadcrumbEntities() {
    const lists = selectAllBreadcrumbLists();
    const out = [];
    lists.forEach((root) => {
      const data = extractBreadcrumbList(root);
      if (data) out.push(data);
    });
    return out;
  }

  /* ---------- Inject JSON-LD ---------- */
  function injectJSONLD(entities) {
    if (!entities.length) return;

    // Verwijder eerdere auto-injecties van dit script (oude en nieuwe classnamen)
    document.querySelectorAll('script[type="application/ld+json"].auto-faq-jsonld, script[type="application/ld+json"].auto-ld-jsonld').forEach((n) => n.parentNode && n.parentNode.removeChild(n));

    entities.forEach((data) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.className = 'auto-ld-jsonld';
      s.text = JSON.stringify(data);
      (document.head || document.documentElement).appendChild(s);
    });
  }

  function run() {
    const faq = collectFAQEntities();
    const breadcrumbs = collectBreadcrumbEntities();
    injectJSONLD([...faq, ...breadcrumbs]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.NovalineFAQLD = { refresh: run };
})();
